import React from 'react';
import { View, Text, Svg, Path, StyleSheet } from '@react-pdf/renderer';
import { PDF_FONTS } from '../pdfTypography';

const BOX = 14;

const styles = StyleSheet.create({
  row: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    paddingVertical: 3,
  },
  checkboxOuter: {
    width: BOX,
    height: BOX,
    border: '1.5px solid #333333',
    marginTop: 2,
    marginRight: 16,
    flexShrink: 0,
  },
  checkboxChecked: {
    width: BOX,
    height: BOX,
    border: '1.5px solid #333333',
    marginTop: 2,
    marginRight: 16,
    flexShrink: 0,
  },
  textCol: {
    flex: 1,
  },
  title: {
    fontSize: PDF_FONTS.body,
    color: '#000000',
    lineHeight: 2,
  },
  description: {
    fontSize: PDF_FONTS.checklistMeta,
    color: '#000000',
    lineHeight: 2,
  },
});

interface ChecklistItemProps {
  title: string;
  description?: string;
  checked?: boolean;
}

const ChecklistItem: React.FC<ChecklistItemProps> = ({ title, description, checked = false }) => (
  <View style={styles.row} wrap={false}>
    <View style={checked ? styles.checkboxChecked : styles.checkboxOuter}>
      {checked && (
        <Svg viewBox="0 0 24 24" width={BOX - 3} height={BOX - 3} style={{ margin: 'auto' }}>
          <Path
            d="M20 6L9 17L4 12"
            stroke="#333333"
            strokeWidth={3.5}
            strokeLinecap="round"
            strokeLinejoin="round"
            fill="none"
          />
        </Svg>
      )}
    </View>
    <View style={styles.textCol}>
      <Text style={styles.title}>{title}</Text>
      {description && <Text style={styles.description}>({description})</Text>}
    </View>
  </View>
);

export default ChecklistItem;
